import { render, staticRenderFns } from "./UEditor.vue?vue&type=template&id=5864190b&scoped=true"
import script from "./UEditor.vue?vue&type=script&lang=js"
export * from "./UEditor.vue?vue&type=script&lang=js"
import style0 from "./UEditor.vue?vue&type=style&index=0&id=5864190b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864190b",
  null
  
)

export default component.exports